import CrudRequest from 'Arch/components/crud/CrudRequest';
import httpService from 'Arch/services/HttpService';

export default class ClientRequest extends CrudRequest {
  static baseUrl() {
    return '/cliente';
  }

  static list(queryParams = {}) {
    return httpService.get(`${this.baseUrl()}/list-all`, {
      params: queryParams,
    });
  }

  static get(id) {
    return httpService.get(`${this.baseUrl()}/endDetalhes/${id}`);
  }

  static getSimple(id) {
    return httpService.get(
      `${this.baseUrl()}/${id}`,
    );
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/add`, payload);
  }

  static getEndereco(cep) {
    return httpService.get(`/api/servicocep-api/Logradouro/Consulta?cep=${cep}`);
  }

  static listCompany() {
    return httpService.get('/produto-servico/empresa/list-all');
  }

  static listClientsByUser(userId, params = {}) {
    return httpService.get(
      `${this.baseUrl()}/usuarioAdmin/${userId}`,
      {
        params,
      },
    );
  }
}
